import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { guid } from '../../utils';

@Component({
  selector: 'vi-ui-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TextareaComponent {
  @Input() public value: string;
  @Input() public label: string;
  @Input() public placeholder: string = '';
  @Input() public disabled: boolean = false;
  @Input() public errorMessage: string;
  @Input() public description?: string;
  @Input() public maxLength?: number;
  @Input() public showCounter: boolean = true;
  @Input() public height: string;
  @Output() public readonly inputChanged = new EventEmitter<string>();
  @Output() public readonly focusedOut = new EventEmitter<string>();

  public readonly DEFAULT_HEIGHT: string = '72px';
  public readonly name: string = guid();
  public readonly descriptionId: string = `${this.name}-description`;
  public readonly counterId: string = `${this.name}-counter`;
  public readonly errorMessageId: string = `${this.name}-error-message`;

  public get counter(): string {
    return this.showCounter && this.maxLength ? `${this.value?.length || 0}/${this.maxLength}` : '';
  }

  public get error(): boolean {
    return !!this.errorMessage;
  }

  public get describedByIds(): string | null {
    if (this.error) {
      return this.errorMessageId;
    }

    const descriptionIds: string[] = [];
    const counter: string = this.counter;

    if (this.description) {
      descriptionIds.push(this.descriptionId);
    }

    if (counter) {
      descriptionIds.push(this.counterId);
    }

    return descriptionIds.length ? descriptionIds.join(' ') : null;
  }

  public onFocusedOut(value: string): void {
    this.focusedOut.emit(value);
  }
}
